module.exports = __webpack_public_path__ + "img/galerie-45.136c06b5.jpg";